module.exports = __webpack_public_path__ + "media/src/img/howhelp-7e6ce3601afe10ead726d448367217d1.png";